module.exports = __webpack_public_path__ + "static/media/73_zinc_metal_seamless.ddf9e3a5.jpg";